import { NgModule } from "@angular/core";
import { UIRouter, UIRouterModule } from "@uirouter/angular";
import { ErrorPagesModule } from "./error/error.module";
import { inventoryFutureState, inventoryStateConfigFn } from "./inventory/inventory";
import { LoginModule } from "./login/login.module";
import { openairDashboardStateDeclaration } from "./openairDashboard/openairDashboard.stateconfig";
import { PortalModule } from "./portal/portal.module";
import { deepLinkState } from "./deepLink/deepLink.stateconfig";

@NgModule({
  imports: [
    PortalModule,
    ErrorPagesModule,
    LoginModule,
    UIRouterModule.forChild({
      states: [
        inventoryFutureState,
        deepLinkState,
        openairDashboardStateDeclaration
      ],
      config: (router: UIRouter) => inventoryStateConfigFn(router)
    })
  ]
})
export class AppModulesModule { }
